@if(job.certifications.length){
<h1 class="header" [ngClass]="{'inactive-job': !job.is_active}">Certifications</h1>
<ul class="description-text" [ngClass]="{'inactive-job': !job.is_active}">
  @for(item of job.certifications; track $index) {
  <li>{{item}}</li>
  }
</ul>
}

@if(job.salary && job.salary.min && job.salary.max && job.salary.period && job.salary.currency) {
<p class="header" [ngClass]="{'inactive-job': !job.is_active}">Salary</p>
<p class="description-text margin-bottom" [ngClass]="{'inactive-job': !job.is_active}">
  {{job.salary.currency === 'USD' ? '$' : job.salary.currency}}{{job.salary.min}}/{{job.salary.period === 'ANNUAL' ? 'yr' : 'month'}} - 
  {{job.salary.currency === 'USD' ? '$' : job.salary.currency}}{{job.salary.max}}/{{job.salary.period === 'ANNUAL' ? 'yr' : 'month'}} </p>
}

@if(job.education.length) {
<p class="header" [ngClass]="{'inactive-job': !job.is_active}">Education and Work Experience:</p>
<ul class="description-text" [ngClass]="{'inactive-job': !job.is_active}">
  @for(item of job.education; track $index) {
  <li>{{item.level | underscoreToLower}}</li>
  }
</ul>
  }